<template>
  <div class="access" >
    <h4 class="access__area-title form-section-title">
      {{ $t('user-manager.editing.access-data.profile-list') }}
      <i
        class="fas fa-info-circle text-blue"
        aria-hidden="true"
        v-b-popover.hover="$t('user-manager.editing.access-data.profile-list-help')"
        title=""
      />
    </h4>
    <div class="access__container">
      <b-row class="access__search-field">
        <b-col xs="12" sm="8" md="6" lg="4" xl="3">
          <s-search-input
            v-model.trim="query"
            :placeholder="$t('user-manager.editing.access-data.search-profile')"
          />
        </b-col>
      </b-row>
      <access-grid :query="query" :user="user"/>
    </div>
  </div>
</template>

<script>
import AccessListDataGrid from './AccessListDataGrid';

export default {
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    AccessGrid: AccessListDataGrid,
  },
  data: () => ({
    query: null,
  }),
  computed: {
    canForward() {
      return (this.user.profiles || []).length > 0;
    },
  },
  created() {
    this.canForwardChanged(this.canForward);
  },
  methods: {
    canForwardChanged(newValue) {
      this.$emit('can-forward-changed', newValue);
    },
  },
  watch: {
    canForward(newValue) {
      this.canForwardChanged(newValue);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.access
  &__search-field
    margin: 15px 5px
  &__container
    border: 1px solid var(--color-border-regular)
    border-radius: 5px
    margin-top: 15px
  ::v-deep .table
    margin-bottom: 0
  +media-min-sm()
  +media-min-md()
  +media-min-lg()
</style>
